import { PopoverNext } from '@blueprintjs/core';
import { OmnisPopoverProps } from './OmnisPopover.types';
import { useThemeContext } from 'app/theme/useThemeContext';

export function OmnisPopover(props: OmnisPopoverProps) {
  const { spacing } = useThemeContext();
  const { minimal, middleware = { offset: { mainAxis: spacing() } }, ...rest } = props;
  return <PopoverNext {...(minimal ? { animation: 'minimal', arrow: false } : {})} middleware={middleware} {...rest} />;
}
